@if (linkRelatedCourseData) {
  <div class="archive_main_cnt" id="alert_popup">
    <div class="Archive_alert_popup">
      <div class="alert_content">Are you sure, you want to {{(linkRelatedCourseData.status?.toLowerCase() === 'unlinked') ? 'link':'unlink'}}?</div>
      <div class="Archive_btn_group">
        <button class="Arch_on" (click)="linkRelatedCourseData=null">NO</button>
        <button class="Arch_yes" (click)="linkOrUnlinkCourse()">YES</button>
      </div>
    </div>
  </div>
}

<div class="campus_avail">
  <div class="avail_create_btn avail_btn_end" [ngClass]="{'disabled':relatedCourseMatData?.pageName?.includes('view')}">
    <button class="custom_btn" roleAccessControl accessType="create" mat-stroked-button (click)="openRelatedCoursePopup('add')"><span class="material-icons">add</span>ADD RELATED COURSE</button>
  </div>
  <div class="campus_avail_table campus_fees_table">
    <table mat-table [dataSource]="relatedCourseList" matSort	class="mat-elevation-z8">
      <ng-container matColumnDef="institutionName">
        <th mat-header-cell *matHeaderCellDef>
          <span class="heading_name">Institution</span>
          <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by name"></span>
        </th>
        <td mat-cell *matCellDef="let relCourse">
          <div class="instances_name">
            <a (click)="openRelatedCoursePopup('edit', relCourse?.pathwayCourseInstanceRelationshipId)" roleAccessControl #roleAccess="accessControl" accessType="edit">{{relCourse.institutionName}}</a>
            @if (!roleAccess?.accessControl) {
              <a (click)="openRelatedCoursePopup('view', relCourse?.pathwayCourseInstanceRelationshipId)">{{relCourse.institutionName}}</a>
            }
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="qualificationType">
        <th mat-header-cell *matHeaderCellDef>
          <span class="heading_name">Qualification type</span>
          <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by type"></span>
        </th>
        <td mat-cell *matCellDef="let relCourse">{{relCourse.qualificationType}}</td>
      </ng-container>
      <ng-container matColumnDef="courseInstanceTitle">
        <th mat-header-cell *matHeaderCellDef>
          <span class="heading_name">Instance Title</span>
          <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by title"></span>
        </th>
        <td mat-cell *matCellDef="let relCourse">{{relCourse.courseInstanceTitle}}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <span class="heading_name">Status</span>
          <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by status"></span>
        </th>
        <td mat-cell *matCellDef="let relCourse">
          <div class="rel_status {{relCourse.status | lowercase}}">{{relCourse.status}}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="menu">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions" roleAccessControl accessType="menu">&nbsp;</th>
        <td class="menu_bar" [matMenuTriggerFor]="menu" mat-cell *matCellDef="let relCourse" roleAccessControl accessType="menu">
          <span class="material-icons">more_horiz</span>
          <mat-menu class="course_menu_table" #menu="matMenu">
            <button mat-menu-item (click)="showAlertPopup(relCourse)" roleAccessControl [accessType]="((relCourse.status?.toLowerCase()==='unlinked')?'link':'unlink')">
              <span>{{(relCourse.status?.toLowerCase() === 'unlinked') ? 'Link':'Unlink'}}</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="relatedCourseColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: relatedCourseColumns;">
      </table>
    </div>
  </div>